import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';
import { grey } from '@mui/material/colors';

interface Props extends BoxProps {
  children: ReactNode;
  hideFrame?: boolean;
  deep?: 1 | 2 | 3 | 4 | 5;
  sx?: BoxProps['sx'];
}

const Frame = ({ children, deep, hideFrame = false, sx = {}, ...rest }: Props) => {
  return (
    <Box
      padding={2}
      {...rest}
      sx={{
        border: deep || hideFrame ? 'none' : `1px solid ${grey[300]}`,
        borderRadius: 2,
        backgroundColor: deep ? grey[`${deep}00`] : 'white',
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default Frame;
